import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { getWebBoosterVairant } from '../../../../constants/webBoosterType';
import {
  getQuickCreateGameModeProps,
  QuickCreateGameMode,
} from '../../../../models/DraftStore';
import { WebBoosterType } from '../../../../models/UserStore';
import { isNotEmptyString } from '../../../../utils/string';
import {
  AppBar,
  BubbleStepsProgressBar,
  PngIcon,
  SvgIcon,
} from '../../../Molecules';

import styles from './CreateMemoryGameContentListTemplate.module.css';

// TODO: change it to baseComponent
type GameContentsProps = {
  question: string;
  answer: string;
  questionPlaceHolder: string;
  answerPlaceHolder: string;
  questionHasTts: boolean;
  questionSoundText: string;
  answerHasTts: boolean;
  answerMissingStrokes: string[];
};

type CreateMemoryGameContentListTemplateProps = {
  type: QuickCreateGameMode | undefined;
  webBoosterType: WebBoosterType | undefined;
  gameContents: GameContentsProps[];
  isNextDisabled: boolean;
  isExceedLimit: boolean;
  showRequiredWarning: boolean;
  isFlashing: boolean;
  expectedPayment: number;
  onClickHelpVideo: () => void;
  onClickEdit: (index: number, type: string) => void;
  onClickRemove: (index: number) => void;
  onClickAddContent: () => void;
  onClickAudioBar: () => void;
  onClickNext: () => void;
  onClickBack: () => void;
};

export const CreateMemoryGameContentListTemplate = (
  props: CreateMemoryGameContentListTemplateProps,
) => {
  const {
    type,
    webBoosterType,
    gameContents,
    isNextDisabled,
    isExceedLimit,
    showRequiredWarning,
    isFlashing,
    expectedPayment,
    onClickHelpVideo,
    onClickEdit,
    onClickRemove,
    onClickAddContent,
    // onClickAudioBar,
    onClickNext,
    onClickBack,
  } = props;
  const { t } = useTranslation();

  const handleEditClick = (index: number, editType: string) => {
    onClickEdit(index, editType);
  };

  return (
    <div className={styles.createMemoryContentList}>
      <AppBar
        title={
          type ? t(getQuickCreateGameModeProps(type, webBoosterType).name) : ''
        }
        onClickBack={onClickBack}
        trailing={
          <>
            {expectedPayment !== 0 && (
              <div className={styles.paymentContainer}>
                <PngIcon name={'CreationStamina'} width={24} height={24} />
                <div className={styles.payTextContainer}>
                  {t('Pay: ')}
                  <p
                    style={{
                      whiteSpace: 'nowrap',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      marginLeft: '3px',
                      lineHeight: 'normal',
                    }}
                  >
                    {expectedPayment}
                  </p>
                </div>
                {/* {`${t('Pay: ')}${expectedPayment}`} */}
              </div>
            )}
          </>
        }
      />
      <div className={styles.userGuideBanner} onClick={onClickHelpVideo}>
        <SvgIcon
          className={styles.questionIcon}
          name={SVGIconType.QuestionHelp}
          color={'#333333'}
        />
        <div className={styles.bannerText}>{t('User Guide')}</div>
        <div className={styles.playerContainer}>
          <SvgIcon
            className={styles.playerIcon}
            name={SVGIconType.PlayerPlay}
            color={'white'}
          />
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          {/* <p className={styles.gameTypeName}>
            {t(getQuickCreateGameModeProps(type).name)}
          </p> */}
          <p className={styles.gameTypeName}>{t('Memory Practice')}</p>
        </div>
        <div className={styles.progress}>
          <BubbleStepsProgressBar currentStep={1} totalSteps={3} />
        </div>

        {/* <p className={styles.title}>{t('+New AI Practice')}</p> */}

        {gameContents.map((gameContent, index) => (
          <div
            key={index}
            id={`game-card-${index}`}
            className={styles.gameCard}
          >
            <div className={styles.gameFooter}>
              <div className={styles.gameNumber}>{index + 1}</div>
              <div className={styles.gameFooterText}>
                {type ? (
                  <SvgIcon
                    name={
                      getQuickCreateGameModeProps(type, webBoosterType).icon
                    }
                    width={24}
                    height={24}
                  />
                ) : null}
                {t(getWebBoosterVairant(webBoosterType).shortCreateName)}
              </div>
              <button
                className={styles.removeButton}
                onClick={() => {
                  onClickRemove(index);
                }}
              >
                <SvgIcon
                  name={SVGIconType.CircleCross}
                  width={24}
                  height={24}
                />
              </button>
            </div>
            <div className={styles.gameHeader}>
              <div className={styles.cardHeader}>
                <SvgIcon
                  name={SVGIconType.LanguageQ}
                  width={24}
                  height={24}
                  color={'black'}
                />
                {t('Question')}
              </div>
              <div
                className={styles.cardQuestion}
                style={{
                  color: gameContent.question ? 'black' : '#808080',
                }}
                onClick={() => {
                  handleEditClick(index, 'Question');
                }}
              >
                <div className={styles.cardContentText}>
                  {gameContent.questionHasTts ? (
                    <div
                      className={styles.audioBar}
                      // onClick={(e) => {
                      //   e.stopPropagation();
                      //   onClickAudioBar();
                      // }}
                    >
                      <SvgIcon
                        name={SVGIconType.PlayerPlay}
                        width={35}
                        height={35}
                        color={'#333'}
                        style={{ opacity: '0.5' }}
                      />
                      <div className={styles.trackTextContainer}>
                        <div className={styles.audioTrack} />
                        <div className={styles.ttsTextContainer}>
                          {'['}
                          <span className={styles.ttsText}>
                            {gameContent.questionSoundText || '---'}
                          </span>
                          {']'}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className={styles.cardText}>
                    {gameContent.question
                      ? gameContent.question
                      : gameContent.questionPlaceHolder}
                  </div>

                  {showRequiredWarning &&
                    !isNotEmptyString(gameContent.question) && (
                      <div className={styles.warningText}>
                        {t('This field is required.')}
                      </div>
                    )}
                </div>
                <SvgIcon
                  className={styles.editButton}
                  name={SVGIconType.Edit}
                  width={20}
                  height={20}
                  color={'#00A698'}
                />
              </div>
              <div className={styles.cardHeader}>
                <SvgIcon
                  name={SVGIconType.LanguageA}
                  width={24}
                  height={24}
                  color={'black'}
                />
                {t(
                  `Answer (${
                    getWebBoosterVairant(webBoosterType).shortCreateName
                  })`,
                )}
              </div>
              <div
                className={styles.cardContent}
                style={{
                  color: gameContent.answer ? 'black' : '#808080',
                  border:
                    showRequiredWarning && !isNotEmptyString(gameContent.answer)
                      ? '1px solid #D95141'
                      : undefined,
                }}
                onClick={() => {
                  handleEditClick(index, 'Answer');
                }}
              >
                <div className={styles.cardContentText}>
                  {/* {gameContent.answerHasTts ? (
                    <div
                      className={styles.audioBar}
                      onClick={(e) => {
                        e.stopPropagation();
                        onClickAudioBar();
                      }}
                    >
                      <SvgIcon
                        name={SVGIconType.PlayerPlay}
                        width={24}
                        height={24}
                        color={'#cccccc'}
                      />
                      <div className={styles.audioTrack} />
                    </div>
                  ) : null} */}
                  <div className={styles.cardText}>
                    {gameContent.answer
                      ? gameContent.answer
                      : gameContent.answerPlaceHolder}
                  </div>

                  {showRequiredWarning &&
                    !isNotEmptyString(gameContent.answer) && (
                      <div className={styles.warningText}>
                        {t('This field is required.')}
                      </div>
                    )}
                  {gameContent.answerMissingStrokes.length > 0 && (
                    <div className={styles.missingStrokeData}>
                      <p>{t('Stroke data not available:')}</p>
                      <p>{gameContent.answerMissingStrokes.join(' ')}</p>
                    </div>
                  )}
                </div>
                <SvgIcon
                  className={styles.editButton}
                  name={SVGIconType.Edit}
                  width={20}
                  height={20}
                  color={'#00A698'}
                />
              </div>
            </div>
          </div>
        ))}

        <button className={styles.addButton} onClick={onClickAddContent}>
          {`+ ${t('Memory Practice')}`}
        </button>
        <p
          className={`${styles.gameCount} ${isFlashing ? styles.flash : ''}`}
          style={{ color: isExceedLimit ? '#D95141' : '#808080' }}
        >
          {t('{count} practice (max. {maxCount})', {
            count: gameContents.length,
            maxCount: 20,
          })}
        </p>
      </div>
      <div className={styles.bottomBar}>
        <div className={styles.nextContainer}>
          <button className={styles.nextButton} onClick={onClickBack}>
            <SvgIcon
              className={styles.leftArrowIcon}
              name={SVGIconType.Arrow}
            />
            <span className={styles.nextText}>{t('Back')}</span>
          </button>
          <button
            className={styles.nextButton}
            onClick={onClickNext}
            disabled={isNextDisabled}
          >
            <span className={styles.nextText}>{t('Next')}</span>
            <SvgIcon
              className={styles.rightArrowIcon}
              name={SVGIconType.Arrow}
            />
            {isNextDisabled ? <div className={styles.blackShadow} /> : null}
          </button>
        </div>
      </div>
    </div>
  );
};
